import React from "react";
import { Box, Chip } from "@mui/material";
import Meet from "containers/pages/CANmeet/Meet";
import logo from '../../assets/images/stream.png';

function MeetPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "95vh", 
      }}
    >
      {/* Main content area */}
      <Box sx={{ flex: 1, p: 4 }}>
        <Meet />
      </Box>

      {/* Footer with Chip */}
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default MeetPage;
